import { MobileAppFrame } from '@eventr/common-storybook'
import { Route, Routes } from 'react-router-dom'
import { useScrollContext } from '../../state/scrollState/scrollContext'
import { scrollRef } from '../../state/scrollState/scrollSignals'
import {
    backgroundImageUrl,
    windowSizes,
} from '../../state/windowState/windowSignals'
import { DevMenuPage } from './devMenuPage'
import { EnvPage } from './environment/envPage'
import { LogsPage } from './logs/logsPage'
import { StorePage } from './store/storePage'
import { TimeSettingsPage } from './time/timeSettingsPage'

export const DevRoutes = () => {
    return (
        <MobileAppFrame
            bottomSafeArea={
                (windowSizes.value.insets?.insets.bottom ?? '0') + 'px'
            }
            topSafeArea={windowSizes.value.insets?.insets.top + 'px'}
            height={'100vh'}
            passedRef={scrollRef.value}
            scrollStyle={{
                scrollBehavior: useScrollContext.getState().scrollBehavior,
            }}
            backgroundImageUrl={backgroundImageUrl.value}
        >
            <Routes>
                <Route path="/" element={<DevMenuPage />} />
                <Route path="/logs" element={<LogsPage />} />
                <Route path="/time" element={<TimeSettingsPage />} />
                <Route path="/env" element={<EnvPage />} />
                <Route path="/store" element={<StorePage />} />
            </Routes>
        </MobileAppFrame>
    )
}
